import * as Sentry from '@sentry/browser';

import { APIErrorResponse } from '@type-def_iqfu/APIErrorResponse';
import { CompaniesListWithPrefectureId } from '@type-def_iqfu/public/AllCompaniesList';
import { CompanyDetailData } from '@type-def_iqfu/public/CompanyDetailData';
import { CompanyListItem } from '@type-def_iqfu/public/CompanyListItem';
import { getCompaniesListQuery } from '@type-def_iqfu/public/getCompaniesListQuery';

import { SearchCompanySortQueries } from '@constants_iqfu';

const queryString = require('query-string');

const backendBasePath = process.env.NEXT_PUBLIC_DEV_BACKEND_URL;

//getStaticProps内で使うのでhooksにしない
const getCompanyDetail = async (companyId: number): Promise<CompanyDetailData | APIErrorResponse | undefined> => {
  const url = `${backendBasePath}/companies/${companyId}`;

  if (isNaN(companyId)) {
    return;
  }

  const result = await fetch(url, {
    method: 'GET',
    mode: 'cors',
  })
    .then((response) => {
      if (!response.ok) {
        return { status: response.status };
      }
      return response.json();
    })
    .catch((error) => {
      return error;
    });
  return result;
};

export type CompanyMapBounds = {
  min_lat: number | null;
  max_lat: number | null;
  min_long: number | null;
  max_long: number | null;
};

//getStaticProps内で使うのでhooksにしない
const getCompaniesList = async (
  queryParams: getCompaniesListQuery,
): Promise<{
  companies: CompanyListItem[];
  noindex: boolean;
  total_count: number;
  //cityのときだけ返る
  company_map_bounds: CompanyMapBounds | null;
}> => {
  if (queryParams.prefecture_code === 0) delete queryParams.prefecture_code;
  if (queryParams.city_code === 0) delete queryParams.city_code;
  const query = queryString.stringify(queryParams);

  const url = `${backendBasePath}/companies?${query}`;

  const result = await fetch(url, {
    method: 'GET',
    mode: 'cors',
  })
    .then((response) => {
      return response.json();
    })
    .catch((error) => {
      Sentry.captureException(error);
      console.error('通信に失敗しました', error);
    });
  return result;
};

const getAllPrefecturesRankings = async (
  sort: keyof typeof SearchCompanySortQueries | undefined,
): Promise<CompaniesListWithPrefectureId[] | void> => {
  const query = queryString.stringify({ sort: sort });

  const url = `${backendBasePath}/companies/all_prefectures_rankings?${query}`;

  const result = await fetch(url, {
    method: 'GET',
    mode: 'cors',
  })
    .then((response) => {
      return response.json();
    })
    .then(
      (data: {
        limit: number;
        rankings: [
          {
            prefecture: {
              code: number;
              name: string;
            };
            companies: CompanyListItem[];
          },
        ];
      }) => {
        const formattedAllPrefecturesCompanyRanking = data.rankings.map((item) => {
          return {
            companies: item.companies,
            prefecture_code: item.prefecture.code,
          };
        });
        return formattedAllPrefecturesCompanyRanking;
      },
    )
    .catch((error) => {
      Sentry.captureException(error);
      console.error('通信に失敗しました', error);
    });
  return result;
};

export { getCompanyDetail, getCompaniesList, getAllPrefecturesRankings };
